import { Button, FormControl, Select, Typography, CircularProgress, MenuItem } from "@material-ui/core"
import { Alert } from '@material-ui/lab'
import { useContext, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link, useHistory } from 'react-router-dom'
import { PaginatedTable, TableColumn } from "../components/Table"
import { OrderContext } from "../OrderContext"
import { getDate } from "../util"
import { Order, ReturnsListContext } from "./ReturnsListContext"

const ReturnsList = () => {
    const { t } = useTranslation()
    const { orders, dateFilter, setDateFilter, loading, page, setPage, hasMaxOrdersReached } = useContext(ReturnsListContext)
    const { customer, ready, readyFailed, initializeOrder, returnsEnabled, exchangesEnabled } = useContext(OrderContext)
    const history = useHistory()

    const columns: TableColumn<Order>[] = useMemo(() => [
        { title: t('order_numbers'), property: 'documentNumber', render: (o) => <Link to={`/order?number=${o}`}>{o as string}</Link> },
        { title: t('date'), property: 'orderDate', render: (d) => getDate(d as string, customer.language) },
        { title: t('order_type'), property: 'type' },
        { title: t('amount_in', { currency: customer.currency }), property: 'netValue' },
        { title: t('status'), property: 'status' },
        { title: t('tracking'), property: 'trackingURL', render: (u) => u ? <a href={u as string} target='_blank' rel="noreferrer">{t('track')}</a> : <span>{t('not_available')}</span> },
    ], [customer, t])

    return (
        <>
            <Typography variant='h4' style={{ marginBottom: 60 }}>{t('returns')}</Typography>

            {hasMaxOrdersReached && (
                <Alert severity="error" style={{ marginBottom: 20 }}>
                    {t('daily_limit_reached')}
                </Alert>
             )} 

            <div style={{ marginBottom: 15 }}>
                <Button variant='contained' color='primary' style={{ float: 'right', height: 40 }} onClick={() => { initializeOrder(); history.push('/return') }} disabled={!ready || (!returnsEnabled && !exchangesEnabled) || hasMaxOrdersReached}>{t('start_new_return')} {!ready && !readyFailed && <CircularProgress size='1.5rem' style={{ marginLeft: '1rem' }} />}</Button>

                <FormControl variant='outlined' size='small'>
                    <Select value={dateFilter} onChange={e => setDateFilter(e.target.value as string)}>
                        <MenuItem value='30days'>{t('30_days')}</MenuItem>
                        <MenuItem value='90days'>{t('90_days')}</MenuItem>
                        {new Array(5).fill(0).map((v, i) => new Date().getFullYear() - i).map(y => <MenuItem key={y} value={y.toString()}>{y}</MenuItem>)}
                        <MenuItem value='5years'>{t('5_years')}</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <PaginatedTable page={page} setPage={setPage} data={orders || []} columns={columns} loading={loading} noRowMessage={t('no_returns_found')} />
        </>
    )
}

export default ReturnsList
